import React from 'react';
import './TeamSingle.css';

import { PageTitle } from '../../../components';

import { FaFacebookF, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt, FaBriefcase } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import { useLocation } from 'react-router-dom';



const TeamSingle = () => {

  const location = useLocation();
  const team = location.state;

  const accounts = team.accounts;
  const contacts = team.contacts;
  const experience = team.experience;
  const skillsContent = team.skills;

  return (
    <>

      {/* Page title */}
      <PageTitle title={'team single'} page={'team single'} />

      <section className='team-single'>

        {/* Team Member Introduction */}
        <div className='team-intro'>

          {/* Team Member Image */}
          <div className='image'>
            <img src={team.image} alt={team.name} />
          </div>

          {/* Team Member Details */}
          <div className='information'>

            <h3>{team.name}</h3> {/* Team Member Name */}
            <h5>{team.title}</h5> {/* Team Member Title */}

            {/* Team Member About */}
            <div className='team-about'>
              <div className='text'>{team.biography}</div> {/* Team Member Biography */}
            </div>

            <ul className="team-personal-info">
              <li><h6><FaPhone className='icon' /> Phone:</h6><span>{contacts.phone}</span></li>
              <li><h6><FaEnvelope className='icon' /> Email:</h6><span>{contacts.email}</span></li>
              <li><h6><FaMapMarkerAlt className='icon' /> Website:</h6><span>{contacts.website}</span></li>
            </ul>

            {/* Social media icons */}
            <div className='icon-container'>
              <a className='icon' href={accounts.facebook}><FaFacebookF /></a> {/* Facebook Icon */}
              <a className='icon' href={accounts.linkedin}><FaLinkedin /></a> {/* LinkedIn Icon */}
              <a className='icon' href={accounts.twitter}><FaXTwitter /></a> {/* Twitter Icon */}
              <a className='icon' href={accounts.instagram}><FaInstagram /></a> {/* Instagram Icon */}
            </div>

          </div>

        </div>

        <div className='box-container page-info'>

          {/* Team Skills */}
          <div className='team-experience sub-section'>

            <h4>Personal Experience</h4>
            <p>{experience.intro}</p>

            <ul>
              {
                // Map over the list of features for the pricing plan and render each feature
                (experience.points).map((list, index) => {
                  return <li key={index}>
                    <div className='icon'><FaBriefcase /></div> {/* Display an icon for each feature */}
                    {list}
                  </li>
                })
              }
            </ul>

          </div>
          
          {/* Team Skills */}
          <div className='team-skills sub-section'>

            <h4>Skills</h4>

            {/* Skills Container */}
            <div className='skills'>

              {/* First set of skills */}
              <div className='skill-item'>
                {/* Rendering skills from the first set */}
                {skillsContent.map(skill => {
                  return(
                    /* skill Box */
                    <div className='box' key={skill.id}> 
                      <h3>{skill.title}<span> {skill.progress}% </span> </h3> {/* Skill title and progress percentage */}
                      <div className='progress-bar'> <span style={{ width: `${skill.progress}%` }}></span> </div> {/* Progress bar */}
                    </div>
                  )
                })}
              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  )
  
}

export default TeamSingle;